import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  defaultSelect: {
    color: theme.palette.grey[700],
  },
  button: {
    padding: '0.3rem 1rem',
    fontSize: '12px',
    marginRight: '10px',
    whiteSpace: 'nowrap',
    textTransform: 'none',
  },
  formControl: {
    margin: `0 ${theme.spacing(2)}`,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  popoverContents: {
    maxWidth: '900px',
  },
}));

export default useStyles;
